<template>
    <div>
        <div class="d-flex justify-content-center" style="margin-bottom:10px">
            <div @click="$emit('stockSynchronize')"><icon-synchronize class="synchronize" style="width: 30px; height: 30px" /></div>
        </div>
        <div class="text text-tertiary text-center">{{text[lang]}}</div>
    </div>
</template>

<script>
// @ is an alias to /src
import IconSynchronize from '@/components/Icons/Synchronize.vue'

export default {
    name: 'try-again',
    props: {
        lang: {
            type: String,
            required: true
        },
        text: {
            type: String,
            default: function() {
                return {
                    es: 'Error al conectar con el servidor. Intente de nuevo...',
                    en: 'Failed to connect to server. Try again...'
                }
            }
        }
    },
    components: {
        IconSynchronize
    }
}
</script>